<template>
  <table class="table table-striped table-sm">
    <tr>
      <td class="font-weight-bold">Flight Number</td>
      <td>{{ data.flightNumber }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">Registration</td>
      <td>{{ data.registration }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">STD (LT)</td>
      <td>{{ data.scheduledTimeOfDepartureLocal | formatDate }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">STA (LT)</td>
      <td>{{ data.scheduledTimeOfArrivalLocal | formatDate }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">Gate ARR/DEP</td>
      <td>{{ data.gate }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">GPU/Pit</td>
      <td>{{ data.gpuPit }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">Delay</td>
      <td>
        <span v-if="data.delay">YES</span>
        <span v-else>NO</span>
      </td>
    </tr>
    <tr v-if="data.delay">
      <td class="font-weight-bold">Delay Code</td>
      <td>{{ data.delayCode }}</td>
    </tr>
    <tr v-if="data.delay">
      <td class="font-weight-bold">Delay Min</td>
      <td>{{ data.delayMin }}</td>
    </tr>
  </table>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Component({})
  export default class GroundOpsFlightInformation extends Vue {
    @Prop() data: any;

  }
</script>

<style lang="scss"></style>
